import { add, parseISO, sub } from "date-fns";

type DateLike = Date | string | null | undefined;

type DueDateFields = {
  dueDate?: DateLike;
  dueDateOffsetDays?: number | null;
  dueDateOffsetAfterInvitationDays?: number | null;
};

type DueDateAnchors = {
  liveStart?: DateLike;
  invitationDate?: DateLike;
};

const toDate = (value: DateLike): Date | null => {
  if (value == null || value === "") return null;
  return value instanceof Date ? value : parseISO(value);
};

/**
 * A task's concrete due date: days after the stand's invitation, else days
 * before the show starts, else its fixed date. Same order as the API's
 * `TaskUtils.getEffectiveDueDate`, which sends reminders off it.
 */
export function resolveEffectiveDueDate(
  task: DueDateFields,
  { liveStart, invitationDate }: DueDateAnchors
): Date | null {
  const invitation = toDate(invitationDate);
  if (task.dueDateOffsetAfterInvitationDays != null && invitation) {
    return add(invitation, { days: task.dueDateOffsetAfterInvitationDays });
  }
  const start = toDate(liveStart);
  if (task.dueDateOffsetDays != null && start) {
    return sub(start, { days: task.dueDateOffsetDays });
  }
  return toDate(task.dueDate);
}

export default resolveEffectiveDueDate;
